<template>
  <div>
    <Head :title="`${order.customer} - show order`" />
    <div class="flex items-center justify-between mb-6">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-600 hover:text-orange-500" href="/pick-up-queue">Pick-up Queue</Link>
      </h1>
      <Link 
        v-if="order.status == 'Pick-up' && order.issuances.length == 0"
        class="btn-orange text-white-400 hover:text-white-600"
        :href="`/pick-up-queues/orders/${order.id}/edit`">Edit</Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full overflow-x-auto">
            <h1 class="text-3xl font-bold">
              Order #{{ order.order_no }} - {{ order.customer }}
            </h1>
          </div>
          <div v-if="order.details.length > 0" class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4 overflow-x-auto">
            <div class="mb-5 pb-5 overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">#</th>
                  <th class="pb-3 pt-3 px-3">SKU</th>
                  <th class="pb-3 pt-3 px-3">Description</th>
                  <th class="pb-3 pt-3 px-3">Qty Ordered</th>
                  <th class="pb-3 pt-3 px-3">Qty Issued</th>
                  <th class="pb-3 pt-3 px-3">UoM</th>
                  <th class="pb-3 pt-3 px-3">Discount (%)</th>
                  <th class="pb-3 pt-3 px-3 items-end justify-end pr-0">Total Amount</th>
                  <th class="pb-3 pt-3 px-3" />
                </tr>
                <tr v-for="(item, index) in order.details" :key="index">
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">{{ index+1 }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-left px-3">{{ item.sku }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-left px-3">{{ item.description }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">{{ item.quantity }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">{{ item.quantity_issued }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">{{ item.measure }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">{{ item.discount_rate }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-end px-3 items-end justify-end pr-3">{{ item.amount }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <Link
                      v-if="order && order.status === 'Pick-up'"
                      :href="`/orders/${order.id}/skus/${item.sku_id}/pick-up/issuance`"
                      class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 pt-1 pb-1"
                    >
                      Issue
                    </Link>
                  </td>
                </tr>
                <tr v-if="order.transport && order.transport > 0">
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">{{ order.details.length + 1 }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-left px-3">{{ order.transport_name }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-left px-3">{{ order.transport_description}}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">1</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">0</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">0</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-center px-3">-</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                    <span class="flex items-end px-3 items-end justify-end pr-3">{{ order.transport }}</span>
                  </td>
                  <td class="w-px border-t pb-1 pt-1">
                  </td>
                </tr>

                <tr v-if="order.voucherInfo && order.voucherInfo.code && order.has_discount_voucher == 0">
                  <td class="pb-3 pt-3  border-t border-b" />
                  <td class="pb-3 pt-3  border-t border-b" colspan="6"> Voucher Code: #{{ order.voucherInfo.code }} - {{ order.voucherInfo.value }} {{ order.voucherInfo.type === 'Percentage' ? '%' : '' }}</td>
                  <td class="pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ order.voucherInfo.voucher_amount }}</span>
                  </td>
                  <td class="pb-3 pt-3  border-t border-b" />
                </tr>
                <tr>
                  <th class="pb-3 pt-3  border-t border-b">Total</th>
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ order.amount }}</span>
                  </th>
                  <th class="pb-3 pt-3  border-t border-b" />
                </tr>
              </table>
            </div>
            <div class="mb-4 overflow-x-auto">
              <p v-show="order.notes"><strong>Notes:</strong> {{ order.notes }}</p>
            </div>
            <div class="mb-4 mt-5 overflow-x-auto">
              <h1 class="text-2xl font-bold">
                Items Issued
              </h1>
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">Date</th>
                  <th class="pb-3 pt-3 px-3">Item UID</th>
                  <th class="pb-3 pt-3 px-3">Part Number</th>
                  <th class="pb-3 pt-3 px-3">Description</th>
                  <th class="pb-3 pt-3 px-3 text-center">Quantity</th>
                  <th class="pb-3 pt-3 px-3">UoM</th>
                  <th class="pb-3 pt-3 px-3">Issued By</th>
                </tr>
                <tr v-for="item in order.issuances" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2 focus:text-orange-500">
                      {{ item.date }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.uid }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.part_umber }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.description }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2 text-center" tabindex="-1">
                      {{ item.quantity }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2 text-center" tabindex="-1">
                      {{ item.measure }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.issued_by }}
                    </span>
                  </td>
                </tr>
                <tr v-if="order && order.issuances.length === 0">
                  <td class="px-6 py-4 border-t" colspan="8">No data found</td>
                </tr>
              </table>
            </div>
            <div class="bg-orange-50 rounded-md shadow overflow-x-auto mb-4">
              <div class="grid grid-cols-1 gap-4 p-1">
                <div class="pt-2 p-2">
                  <h1 style="font-size:20px; font-weight: bold;">
                    Payment Details
                  </h1>
                </div>
              </div>
            </div>
            <div v-if="order.payments.length" class="mb-4 overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">#</th>
                  <th class="pb-3 pt-3 px-3">Date</th>
                  <th class="pb-3 pt-3 px-3">Payment Mode</th>
                  <th class="pb-3 pt-3 px-3">Reference</th>                  
                  <th class="pb-3 pt-3 px-3">Initiated By</th>
                  <th class="pb-3 pt-3 px-3">Phone Number</th>
                  <th class="flex items-end px-3 items-end justify-end">Amount</th>
                </tr>
                <tr v-for="(item, index) in order.payments" :key="index">
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ index+1 }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.date }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-left px-3">{{ item.provider }}</span>
                  </td>
                  <td 
                    class="w-px border-t pb-3 pt-3 break-all" 
                    style="word-wrap: break-word !important; word-break: break-all !important; white-space: normal !important; width: 30%;">
                    <p class="px-3">{{ item.reference }}</p>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ item.user }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-center px-3">{{ item.phone_number }}</span>
                  </td>
                  <td class="w-px border-t pb-3 pt-3">
                    <span class="flex items-end px-3 items-end justify-end">{{ item.amount }}</span>
                  </td>                  
                </tr>
                <tr>
                  <th class="pb-3 pt-3  border-t border-b">Total</th>
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b" />
                  <th class="pb-3 pt-3  border-t border-b">
                    <span class="flex items-end px-3 items-end justify-end">{{ order.total_payments }}</span>
                  </th>
                </tr>
              </table>              
            </div>

          </div>
          <div v-else class="p-5">No order details not found.</div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <a 
                v-if="((order.invoice && order.invoice.taxilla_status === 'completed'))"
                class="btn btn-orange text-xs cursor-pointer ml-1 mr-1"
                :href="`/download-taxilla-pdf-invoices/${order.invoice.id}`"
                target="__blank"
                title="Download">
                <span>Download Invoice</span>
              </a>
            </span>
            <span v-show="amountToPay > 0" class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button v-if="!(order.status =='Declined' || order.status =='Cancelled')" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 ml-1 mr-1" @click="makePaymentModel(order)">
                Initiate Payment
              </button>
            </span>
            <span v-if="order && order.issuances.length > 0 && !(order.status =='Declined' || order.status =='Delivered' || order.status =='Cancelled')" class="mt-3 mr-2 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="markInvoicedPrompt">
                Invoice
              </button>
            </span>
            <span v-if="order && order.issuances.length > 0 && order.status === 'Invoiced'" class="mt-3 mr-2 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="markInvoiceAsDeliveredPrompt">
                Mark Delivered
              </button>
            </span>
            <span v-if="order && order.issuances.length == 0 && order.status === 'Pick-up'" class="mt-3 mr-2 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="cancelOrderPrompt">
                Cancel
              </button>
            </span>
          </div>
        </form>
    </div>
  </div>
  <div v-if="isMakePaymentOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex flex-wrap w-full items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1>Make Payment for order#{{ order.order_on }}</h1>
          </div>
          <div v-if="!merchantRequestId" class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div
                class="flex flex-wrap w-full w-full"
              >
                <div class="pb-2 pr-6 w-full lg:w-full">
                  <text-input
                    v-model="formDat.phone_number"
                    :error="phonenumberError"
                    placeholder="Phone Number"
                    label="Phone Number"
                  />
                </div>
                <div class="pb-2 pr-6 w-full lg:w-full">
                  <text-input
                    v-model="formDat.amount"
                    :error="amountError"
                    class="pb-2"
                    placeholder="Amount"
                    label="Amount"
                  />
                </div>
              </div>
            </div>
            <div v-if="loading" style="color:green"><p> Processing, kindly wait...</p></div>
            <div v-else>
              <p v-if="status == 1 && mpesa_response" style="color:green">
                <div class="flex items-center justify-between mb-6">
                  <p>{{ mpesa_response }}</p>
                  <span class="mt-3 flex w-1/3 rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                  bg-green-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500
                  focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm
                  sm:leading-5" @click="checkPayment()">
                      Refresh
                    </button>
                  </span>
                </div>
              </p>
              <p v-else-if="status == 0 && mpesa_response" style="color:red">{{ mpesa_response }}</p>
              <p v-else></p>
            </div>
          </div>
          <div v-else class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div v-if="message" class="flex items-center justify-between mb-6">
              <span v-if="complete == 'completed'" style="color:green">
                <p>{{ message }} </p>
              </span>
              <span v-else>
                <p style="color: red">{{ message }} </p>
              </span>
            </div>
            <div v-else class="flex items-center justify-between mb-6">
              <span>
                <p>Click the refresh button.</p>
              </span>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-if="!merchantRequestId"
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500
                focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm
                sm:leading-5"
                @click="confirmMakePaymentModel()"
              >
                Send
              </button>
              <button v-else type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-green-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500
                focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm
                sm:leading-5" @click="checkPayment()">
                  Refresh
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closePaymentModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div v-if="openMarkInvoicedPrompt" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1 style="font-size: 20px;">
              <strong>Invoice  - Order #{{ order.order_no }} - {{ order.customer }} </strong>
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="w-full lg:w-full pb-2 pr-6">
                <multiselect
                  id="entity"
                  v-model="form.processing_type"
                  placeholder="Search Processing Type"
                  :options="entities"
                  :close-on-select="true"
                  :searchable="true"
                  :error="$props.errors.processing_type"
                  :style="$props.errors.processing_type ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                />
                <div v-if="$props.errors.processing_type" class="form-error">{{ $props.errors.processing_type }}</div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                Cancel
              </button>
            </span>
            <span class="mt-3 mr-2 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="submitMarkInvoiced">
                Invoice
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openMarkInvoiceAsDeliveredPrompt" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1 style="font-size: 20px;">
              Invoice  - Order #{{ order.order_no }} - {{ order.customer }}
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to mark an invoice as <strong>Delivered</strong>, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeDeliveredModal">
                Cancel
              </button>
            </span>
            <span class="mt-3 mr-2 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="submitMarkInvoiceAsDelivered">
                Send
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openConcelOrderPrompt" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1 style="font-size: 20px;">
              Invoice  - Order #{{ order.order_no }} - {{ order.customer }}
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to cancel this order <strong>{{ order.order_no }}</strong>, do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeCancelModal">
                No
              </button>
            </span>
            <span class="mt-3 mr-2 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500
                focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm
                sm:leading-5" @click="cancelOrder">
                Yes
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="openIssueToDispatch" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white w-4/4 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
          <h1 style="font-size: 20px;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6" style="display: inline !important;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z" />
            </svg>
            {{ selectedSku }}
          </h1>
        </div>
        <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
          <div class="mb-4">
            <div class="bg-white rounded-md shadow mb-5">
              <form @submit.prevent="storeIssue">
                <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pl-8 pr-8 pb-8">
                  <div class="w-1/2 lg:w-1/2">
                    <text-input
                      v-model="issueData.quantity"
                      :error="$props.errors.quantity"
                      class="pb-2 pr-6 w-full lg:w-full"
                      placeholder="Quantity"
                    />
                  </div>
                  <div class="w-1/2 lg:w-1/2">
                    <text-input
                      v-model="issueData.item_id"
                      :error="$props.errors.item_id"
                      class="pb-2 pr-6 w-full lg:w-full"
                      placeholder="Scan UID"
                    />
                  </div>
                </div>
                <div
                  class="flex items-center justify-end w-full px-8 py-4 bg-gray-50 border-t border-gray-100"
                >
                  <button
                    class="btn-orange px-3 py-2 text-xs"
                    type="submit"
                  >
                    Issue
                  </button>
                </div>
              </form>
            </div>
            <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
              <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-3 pt-3 px-3">Date</th>
                  <th class="pb-3 pt-3 px-3">Item UID</th>
                  <th class="pb-3 pt-3 px-3">Part Number</th>
                  <th class="pb-3 pt-3 px-3">Description</th>
                  <th class="pb-3 pt-3 px-3 text-center">Quantity</th>
                  <th class="pb-3 pt-3 px-3">UoM</th>
                  <th class="pb-3 pt-3 px-3">Issued By</th>
                </tr>
                <tr v-for="item in listSkuIssuances" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2 focus:text-orange-500">
                      {{ item.date }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.uid }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.part_umber }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.description }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2 text-center" tabindex="-1">
                      {{ item.quantity }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2 text-center" tabindex="-1">
                      {{ item.measure }}
                    </span>
                  </td>
                  <td class="border-t">
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.issued_by }}
                    </span>
                  </td>
                </tr>
                <tr v-if="listSkuIssuances.length === 0">
                  <td class="px-6 py-4 border-t" colspan="8">No data found</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeIssuanceModal">
              Close
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div v-if="openInvoice" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle bg-white w-3/4" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
          <h1 style="font-size: 20px;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6" style="display: inline !important;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z" />
            </svg>
            Invoice #{{ order.invoice.invoice_no }} {{ order.customer }}
          </h1>
        </div>
        <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4 invoice-print">
          <div class="mb-4">
            <div class="bg-white overflow-x-auto mt-5">
              <table width="100%" class="pt-5 pb-5 mb-5" cellpadding="5" style="border: 0px solid !important;">
                <tr>
                  <td width="30%"><img src="/images/logo.jpg" /></td>
                  <td style="padding-left: 20px !important;">
                    Duldul Godowns Phase 3 No B4 <br />
                    Mombasa Road, Nairobi<br />
                    +254 (0) 716 612 797 (Sales)<br />
                    +254 (0) 716 612 747 (Office)<br />
                    sales@watervale.co.ke / info@watervale.co.ke<br />
                    PIN # P051458723J
                  </td>
                  <td>
                    <table>
                      <tr>
                        <td colspan="2">
                          <h1 class="text-3xl font-bold">TAX INVOICE</h1>
                        </td>
                      </tr>
                      <tr>
                        <td width="50%">Invoice</td>
                        <td width="50%">#{{ order.invoice.invoice_no }}</td>
                      </tr>
                      <tr>
                        <td width="50%">Date</td>
                        <td width="50%">{{ order.invoice.date }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              <table width="100%" class="pt-5 mt-5">
                <tr>
                  <td width="50%" style="padding: 20px !important;">
                    <p>Invoice To</p>

                    <p class="pt-5">
                      {{ order.customer }}
                    </p>
                    <p>
                      LPO#{{ order.order_no }}
                    </p>
                  </td>
                  <td style="padding: 20px !important; border-left:1px solid black !important; border-top:1px solid black !important; border-right:1px solid black !important;">
                    All payments shall STRICTLY be made to the official MPESA, or
                    directly to the company bank Accounts indicated below. No cash
                    payments shall be made to our staff or any individual directly or
                    via MPESA on personal lines. Cheques accepted only by prior
                    arrangement made to “Watervale Investments Ltd”.
                  </td>
                </tr>
              </table>
              <table width="100%" class="pt-5 pb-5 mb-5" cellpadding="5" style="border: none !important;">
                <tr>
                  <td width="31%" style="padding-left: 10px !important; text-align: center !important; border: 1px solid black !important;">
                    BANK NAME:Victoria Commercial Bank<br />
                    A/C NUMBER: 1011542017<br />
                    BANK BRANCH: LUNGA LUNGA SQUARE
                  </td>
                  <td style="padding-left: 10px !important; text-align: center !important; border: 1px solid black !important;">
                    BANK NAME: Standard Chartered Bank<br />
                    A/C NUMBER: 0102487890700<br />
                    BANK BRANCH: Industrial Area Branch
                  </td>
                  <td style="padding-left: 10px !important; text-align: center !important; border: 1px solid black !important;">
                    M-PESA: Till Number #5264667<br />
                    (Kindly share proof of payment with<br />
                    the delivery person)
                  </td>
                </tr>
              </table>
              <table width="100%" style="margin-bottom: 50px;">
                <tr class="text-left font-bold" style="border-bottom: 1px solid black !important;">
                  <th class="pb-3 pt-3 px-3" style="border-bottom: 1px solid black !important;">Item</th>
                  <th class="pb-3 pt-3 px-3" style="border-bottom: 1px solid black !important;">Qty</th>
                  <th class="pb-3 pt-3 px-3" style="border-bottom: 1px solid black !important;">Unit Price</th>
                  <th class="pb-3 pt-3 px-3" style="border-bottom: 1px solid black !important;">Amount</th>
                </tr>
                <tr v-for="item in order.invoice.details" :key="item.id">
                  <td>
                    <span class="flex items-center px-3 py-2 focus:text-orange-500">
                      {{ item.sku }}_{{ item.description }}
                    </span>
                  </td>
                  <td>
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.quantity }}
                    </span>
                  </td>
                  <td>
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.price }}
                    </span>
                  </td>
                  <td>
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ item.amount }}
                    </span>
                  </td>
                </tr>
                <tr v-if="order.invoice.has_discount_voucher == 0">
                  <td colspan="3">
                    <span class="flex items-center px-3 py-2">
                      Voucher# {{ order.invoice.voucher_code }} {{ order.invoice.voucher_details }}
                    </span>
                  </td>
                  <td>
                    <span class="flex items-center px-3 py-2" tabindex="-1">
                      {{ order.invoice.voucher_amount }}
                    </span>
                  </td>
                </tr>
              </table>
              <table width="100%" class="pt-5 pb-5 mb-5" cellpadding="5" style="border: none !important; margin-top: 50px;">
                <tr>
                  <td width="70%" style="padding-left: 10px !important;">
                    Remarks<br />
                  </td>
                  <td style="padding-left: 10px !important; margin-top: 50px !important;">
                    <table width="100%">
                      <tr>
                        <td width="50%">SubTotal</td>
                        <td width="50%" style="text-align: right !important;"><strong>{{ order.invoice.sub_total }}</strong></td>
                      </tr>
                      <tr>
                        <td width="50%">VAT</td>
                        <td width="50%" style="text-align: right !important;"><strong>{{ order.invoice.tax }}</strong></td>
                      </tr>
                      <tr>
                        <td width="50%">Total</td>
                        <td width="50%" style="text-align: right !important;"><strong>{{ order.invoice.gross_amount }}</strong></td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              <table width="100%" class="pt-5 pb-5 mb-5" cellpadding="5" style="border: none !important;">
                <tr>
                  <td style="padding-left: 10px !important;">
                    <img src="/images/footer_file.jpg" />
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 ml-2 mr-2" @click="closeIssuanceModal">
              Close
            </button>
          </span>
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <a
              class="btn btn-orange text-xs cursor-pointer"
              :href="`/orders/${order.id}/pdf${url()}`" 
              download
              target="__blank"
              title="Download"
            >
              <span>Download</span>
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div v-if="isMakePaymentOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex flex-wrap w-full items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1>Make Payment for order#{{ order.order_on }}</h1>
          </div>
          <div v-if="!merchantRequestId" class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div
                class="flex flex-wrap w-full w-full"
              >
                <div class="pb-2 pr-6 w-full lg:w-full">
                  <text-input
                    v-model="formDat.phone_number"
                    :error="phonenumberError"
                    placeholder="Phone Number"
                    label="Phone Number"
                  />
                </div>
                <div class="pb-2 pr-6 w-full lg:w-full">
                  <text-input
                    v-model="formDat.amount"
                    :error="amountError"
                    class="pb-2"
                    placeholder="Amount"
                    label="Amount"
                  />
                </div>
              </div>
            </div>
            <div v-if="loading" style="color:green"><p> Processing, kindly wait...</p></div>
            <div v-else>
              <p v-if="status == 1 && mpesa_response" style="color:green">
                <div class="flex items-center justify-between mb-6">
                  <p>{{ mpesa_response }}</p>
                  <span class="mt-3 flex w-1/3 rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                  bg-green-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500
                  focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm
                  sm:leading-5" @click="checkPayment()">
                      Refresh
                    </button>
                  </span>
                </div>
              </p>
              <p v-else-if="status == 0 && mpesa_response" style="color:red">{{ mpesa_response }}</p>
              <p v-else></p>
            </div>
          </div>
          <div v-else class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div v-if="message" class="flex items-center justify-between mb-6">
              <span v-if="complete == 'completed'" style="color:green">
                <p>{{ message }} </p>
              </span>
              <span v-else>
                <p style="color: red">{{ message }} </p>
              </span>
            </div>
            <div v-else class="flex items-center justify-between mb-6">
              <span>
                <p>Click the refresh button.</p>
              </span>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                v-if="!merchantRequestId"
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500
                focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm
                sm:leading-5"
                @click="confirmMakePaymentModel()"
              >
                Send
              </button>
              <button v-else type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-green-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500
                focus:outline-none focus:border-green-700 focus:shadow-outline-green sm:text-sm
                sm:leading-5" @click="checkPayment()">
                  Refresh
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closePaymentModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isConfirmPaymentOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <p>
                You are about to initiate payment from <strong>{{ order.customer }} {{ order.contact }}</strong>. Proceed?
              </p>
            </div>
          </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2
                bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500
                focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm
                sm:leading-5"
                @click="makePaymentOrder()"
              >
              Yes
            </button>
          </span>
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button @click="closeConfirmMakePaymentModel" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
              Cancel
            </button>
          </span>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import Multiselect from '@vueform/multiselect'
import SelectInput from '@/Shared/SelectInput'
import axios from 'axios'

export default {
  components: {
    Head,
    Icon,
    Link,
    TextInput,
    Multiselect,
    SelectInput,
  },
  layout: Layout,
  props: {
    order: Object,
    providers: Object,
    errors: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        processing_type: '',
        orderId: this.order.id,
      }),
      entities: [
        {
          label : 'Taxilla',
          value : 'Taxilla',
        },
        {
          label : 'Direct',
          value : 'Direct',
        }
      ],
      formDat: {
        order_id: null,
        order_no: null,
        phone_number: null,
        amount: null,
        customer_name: null,
      },
      openCreateOrder: false,
      openDetail: false,
      openMarkInvoicedPrompt: false,
      openIssueToDispatch: false,
      openInvoice: false,
      qtyOrdered: null,
      stepOne: true,
      stepTwo: false,
      listDetails: [],
      listSkuIssuances: [],
      orderObjTest: [],
      selectedCustomer: null,
      selectedSku: null,
      selectedSkuId: null,
      selectedOrderItemId: null,
      issueData: {
        'item_id': null,
        'quantity': null,
      },
      invoiceData: {},
      invoiceobj: {},
      askDelete: false,
      showAddPayment: false,
      isConfirmPaymentOpen: false,
      isMakePaymentOpen: false,
      mpesa_response: null,
      status: 0,
      merchantRequestId: null,
      amountError: null,
      phonenumberError: null,
      loading: false,
      complete: null,
      message: null,
      openMarkInvoiceAsDeliveredPrompt: false,
      openConcelOrderPrompt: false,
    }
  },
  computed: {
    amountToPay() {
      const totalPaid = this.order.total_payments ? this.order.total_payments.replace(/,/g,"") : 0
      const amountToPay = this.order.amount ? this.order.amount.replace(/,/g,""): 0
      const total = (amountToPay - totalPaid)
      this.formDat.amount = total
      return total
    },
    user() {
      return this.$inertia.page.props.auth.user
    },
    totalOrder() {
      let totOrder = 0
      if (this.order.details) {
        this.order.details.forEach((amount)=>{ 
          totOrder += parseFloat(amount.amount)
        })
      }
      return totOrder
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    cancelOrderPrompt() {
      this.openConcelOrderPrompt = true
    },
    closeCancelModal() {
      this.openConcelOrderPrompt = false
    },
    markInvoicedPrompt() {
      this.openMarkInvoicedPrompt = true
    },
    markInvoiceAsDeliveredPrompt() {
      this.openMarkInvoiceAsDeliveredPrompt = true
    },
    previewInvoicePrompt(item) {
      this.openInvoice = true
      this.invoiceobj = item.invoice
    },
    openCreateOrderPrompt() {
      this.openCreateOrder = true
    },
    closeModal() {
      this.openCreateOrder = false
      this.openDetail = false
      this.openMarkInvoicedPrompt = false
      this.openInvoice = false
    },
    closeDeliveredModal() {
      this.openCreateOrder = false
      this.openDetail = false
      this.openMarkInvoicedPrompt = false
      this.openInvoice = false
      this.openMarkInvoiceAsDeliveredPrompt = false
    },
    makePaymentModel(order) {
      this.formDat.order_id = order.id
      this.formDat.customer_name = order.customer
      this.formDat.order_on = order.order_no
      this.openCreateOrder = false
      this.openDetail = false
      this.askDelete = false
      this.showAddPayment = false
      this.isConfirmPaymentOpen = false
      this.isMakePaymentOpen = true
    },
    closePaymentModal() {
      this.openCreateOrder = false
      this.openDetail = false
      this.askDelete = false
      this.showAddPayment = false
      this.isMakePaymentOpen = false
      this.mpesa_response = null
      this.formDat.phone_number = null
      this.isConfirmPaymentOpen = false
      this.merchantRequestId = null
      this.message = null
      this.complete = null
      // window.location.reload()
    },
    closeConfirmMakePaymentModel() {
      this.openCreateOrder = false
      this.openDetail = false
      this.askDelete = false
      this.showAddPayment = false
      this.openEditOrder = false
      this.isMakePaymentOpen = true
      this.isConfirmPaymentOpen = false
    },
    openDetailPrompt(item) {
      this.openDetail = true
      this.listDetails = item.details
      this.order = item
    },
    cancelOrder() {
      this.invoiceData.order_id = this.order.id
      this.invoiceData.is_active = this.order.issuances.length > 0
      this.invoiceData._method = 'POST'
      this.$inertia.post(`/pick-up-queues/orders/${this.order.id}/cancel`, this.invoiceData, {
        onSuccess: () => {
          this.openConcelOrderPrompt = false
        },
      })
    },
    submitMarkInvoiced() {
      this.invoiceData.order_id = this.order.id
      this.invoiceData.processing_type = this.form.processing_type
      this.invoiceData._method = 'POST'
      this.$inertia.post('/invoice-online-order', this.invoiceData, {
        onSuccess: () => {
          this.openDetail = false
          this.openMarkInvoicedPrompt = false
        },
      })
    },
    submitMarkInvoiceAsDelivered() {
      this.invoiceData.order_id = this.order.id
      this.invoiceData._method = 'POST'
      this.$inertia.post('/invoice-online-order-delivered', this.invoiceData, {
        onSuccess: () => {
          this.openDetail = false
          this.openMarkInvoicedPrompt = false
          this.openMarkInvoiceAsDeliveredPrompt = false
        },
      })
    },
    makePaymentOrder() {
      const data = {}
      data.order_id = this.formDat.order_id
      data.phone_number = this.formDat.phone_number
      data.amount = this.formDat.amount
      data._method = 'POST'
      const self = this
      self.loading = true;
      this.isConfirmPaymentOpen = false
      axios.post('/payments/process', data).then(response => {
        if (response) {
          self.show = true
          self.mpesa_response = response.data.message
          self.status = response.data.status
          self.stepOne = true
          self.stepTwo = false
          self.openCreateOrder = false
          self.isMakePaymentOpen = true
          self.isConfirmPaymentOpen = false
          self.merchantRequestId = response.data.merchant_request_id
        }
      }).catch(function(error) {
        if (error.response.status === 422) {
          const { amount, phone_number } = error.response.data.errors
          if (phone_number) {
            const [n] = phone_number;
            self.phonenumberError = n
          }
          if (amount) {
            const [a] = amount;
            self.amountError = a
          }
        }
        self.isConfirmPaymentOpen = false
        self.isMakePaymentOpen = true
      }).then(() => {
        self.loading = false;
      })
    },
    confirmMakePaymentModel() {
      this.openCreateOrder = false
      this.openDetail = false
      this.askDelete = false
      this.showAddPayment = false
      this.isConfirmPaymentOpen = true
      this.isMakePaymentOpen = true
      this.mpesa_response = null
      this.loading = false
      this.status = 0
    },
    checkPayment() {
      const data = {}
      data.merchant_request_id = this.merchantRequestId
      const self = this
      axios.post('/payments/check-payment', data).then(response => {
        if (response) {
          self.message = response.data.message
          self.complete = response.data.status
          self.isMakePaymentOpen = true
          self.status = null
          self.mpesa_response= null
        }
      }).catch(function(error) {

      })
    },
    showNext() {
      this.stepOne = false
      this.stepTwo = true
    },
    showBack() {
      this.stepOne = true
      this.stepTwo = false
    },
    addItem(e) {
      e.preventDefault()
      this.formData.details.push({
        part_number: null,
        quantity: null,
      })
    },
    removeItem(index, details) {
      details.splice(index, 1)
    },
    showValidationErrors(value) {
      if (this.$props.errors) {
        const error = this.$props.errors[value] || ''
        return error || ''
      }
      return ''
    },
    onSelect(id, item) {
      this.selectedCustomer = item.label
    },
    closeIssuanceModal() {
      this.openIssueToDispatch = false
      this.openInvoice = false
    },
    url() {
      let query = ''
      if (this.order) {
        query += `oid=${this.order.id}`
      }
      if (query) {
        query = `?${query}`
      }
      return query
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .modal-wrapper h1 {
    font-size: 20px;
    font-weight:bold;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .approved {
    color: green;
  }
  .declined {
    color: red;
  }
</style>